import { Component, OnInit } from '@angular/core';
declare var $:any;
@Component({
  selector: 'app-achievement',
  templateUrl: './achievement.component.html',
  styleUrls: ['./achievement.component.scss']
})
export class AchievementComponent implements OnInit {
  imgUrl:string[]=[
    
    '/assets/img/achievement/4.jpg',
    '/assets/img/showcase/1.jpg',
    // '/assets/img/achievement/2.jpeg',
    // '/assets/img/achievement/3.jpeg',
  ]
  constructor() { }

  ngOnInit(): void {
    $('#firstCarousel').carousel({
      interval: 4000
    })
  }
  counterQuery(){
    $(".counter").counterUp(
      {
        delay:10,
        time:1000
      }
    );
  }
}
